/*
 *  Home Hero
 *    Scripts for the Home Hero Carousel use on the home page.
 *
 *
 *  Version:
 *    1.0.0 - 2019/07/18
 */

import { CarouselSection } from './../../sections/carousel/CarouselSection';
import { register } from './../../sections/ShopifySection';
import * as ResponsiveSizes from './../../settings/Responsive';

export const CONTAINER_SELECTOR = '[data-home-hero]';
export const CAROUSEL_SELECTOR = '[data-home-hero-carousel]';


export class HomeHero extends CarouselSection {
  constructor(container) {
    super(container);
    this.carouselContainer = container.find(CAROUSEL_SELECTOR);

    this.slick = this.initCarousel(this.carouselContainer);
  }

  optionOverrides() {
    return {
      infinite: this.container.data('infinite') === true ? true : false,
      autoplay: this.container.data('autoplay') == true,
      autoplaySpeed: (this.container.data('autoplay-speed') * 1000) || 5000,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: false,
      dots: true,
      responsive: [
        {
          breakpoint: ResponsiveSizes.xsmall-1,
          settings: { slidesToShow: 1, slidesToScroll: 1 }
        },
        {
          breakpoint: ResponsiveSizes.medium-1,
          settings: { slidesToShow: 1, slidesToScroll: 1, dots: true }
        },
        {
          breakpoint: ResponsiveSizes.large-1,
          settings: { slidesToShow: 1, slidesToScroll: 1,  dots: true }
        }
      ]
    }
  }
}

register(CONTAINER_SELECTOR, HomeHero);